let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3VKXz")).then(() => parcelRequire('b8Z4e'));